import { useState, useEffect, MutableRefObject } from 'react';

const useVisible = (ref: MutableRefObject<HTMLElement> | undefined, rootMargin = '', threshold = 0) => {
    const [visibility, setVisibility] = useState<boolean>(false);

    useEffect(() => {
        let observerRefValue: HTMLElement = null;
        const observer = new IntersectionObserver(
            ([entry]) => {
                setVisibility(entry.isIntersecting);
            },
            { rootMargin, threshold }
            // TODO, try to make it so it only happens when visible on screen, root viewport ref not working
        );
        if (ref.current) {
            observer.observe(ref.current);
            observerRefValue = ref.current;
        }
        return () => {
            if (observerRefValue) {
                observer.unobserve(observerRefValue);
            }
        };
    });

    if (!window.IntersectionObserver) {
        return true;
    }

    return visibility;
};

export default useVisible;



// WEBPACK FOOTER //
// ./src/util/hooks/use-visible.ts